import { Injectable, ElementRef } from "@angular/core";
import { Broadcaster } from "app/components/service/Broadcaster";
import { SingService } from "app/components/service/sing.service";
import { GeneralService } from "app/components/class/general.service";

@Injectable()
export class Action {
    constructor(private elRef: ElementRef, private broadcaster: Broadcaster, private httpService: SingService, public generalService: GeneralService) {

    }
    public getAuthData() {
        return this.httpService.getAuthData();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/left-panel/services/action.service.ts